

import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { DollarSign, Users, BarChart } from 'lucide-react';

interface AICostOverviewProps {
  timeRange: '7d' | '30d' | '90d' | 'all';
  totalCost: number;
  totalTokens: number;
  totalUsers: number;
}

function getTimeRangeLabel(timeRange: '7d' | '30d' | '90d' | 'all'): string {
  switch (timeRange) {
    case '7d':
      return 'Last 7d';
    case '30d':
      return 'Last 30d';
    case '90d':
      return 'Last 90d';
    case 'all':
      return 'All Time';
    default:
      return 'Last 30d';
  }
}

export function AICostOverview({ 
  timeRange, 
  totalCost, 
  totalTokens, 
  totalUsers 
}: AICostOverviewProps) {
  const timeLabel = getTimeRangeLabel(timeRange);
  
  return (
    <div className="grid gap-4 md:grid-cols-3">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Total Cost</CardTitle>
          <DollarSign className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">${totalCost.toFixed(2)}</div>
          <p className="text-xs text-muted-foreground">{timeLabel}</p>
        </CardContent>
      </Card>
      
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Total Tokens</CardTitle>
          <BarChart className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{totalTokens.toLocaleString()}</div>
          <p className="text-xs text-muted-foreground">{timeLabel}</p>
        </CardContent>
      </Card>
      
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Unique Users</CardTitle>
          <Users className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{totalUsers}</div>
          <p className="text-xs text-muted-foreground">With AI interactions</p>
        </CardContent>
      </Card>
    </div>
  );
}
